import { TextField as MuiTextField } from '@mui/material';
import { castArray } from 'lodash-es';
import type { FC } from 'react';
import type { TextFieldProps } from './TextField.types';

const TextField: FC<TextFieldProps> = ({
  isFieldReadOnly,
  isFieldOptional,
  field,
  testPrefix,
  ...rest
}) => (
  <MuiTextField
    {...rest}
    sx={[
      (theme) => (isFieldReadOnly ? theme.mixins.readOnlyInputStyle : {}),
      ...castArray(rest.sx),
    ]}
    id={field.code}
    name={field.code}
    label={isFieldOptional ? `${field.name} (optional)` : field.name}
    type={rest.type || 'text'}
    value={rest.value || ''}
    autoComplete="off"
    slotProps={{
      htmlInput: {
        ...rest.inputProps,
        ...(isFieldReadOnly && { readOnly: true }),
        'data-test': testPrefix,
      },

      inputLabel: isFieldReadOnly ? { shrink: true } : {},
    }}
  />
);

export default TextField;
